type ThreadElementCropper = (document: Document) => string | undefined;

type ThreadElementCropperFactory<TArgs = any> = (args: TArgs) => ThreadElementCropper;

const createQueryThreadElementCropper: ThreadElementCropperFactory = (query: string) => {
  return (document) => {
    const threadElement = document.querySelector(query);

    if (threadElement) {
      threadElement.remove();
    }

    return threadElement?.innerHTML;
  };
};

const createHtmlSeparatorThreadElementCropper: ThreadElementCropperFactory = (
  separatorHtml: string
) => {
  return (document) => {
    const appendElementIndex = document.body.innerHTML.indexOf(separatorHtml);
    if (appendElementIndex === -1) {
      return undefined;
    }

    const threadElementHtml = document.body.innerHTML.substring(appendElementIndex);
    document.body.innerHTML = document.body.innerHTML.substring(0, appendElementIndex - 1);

    return threadElementHtml;
  };
};

const createQuerySeparatorThreadElementCropper: ThreadElementCropperFactory = (
  separatorQuery: string
) => {
  return (document) => {
    const separatorElement = document.querySelector(separatorQuery);

    if (!separatorElement) {
      return undefined;
    }

    return createHtmlSeparatorThreadElementCropper(separatorElement.innerHTML)(document);
  };
};

const threadElementCroppers: ThreadElementCropper[] = [
  // Gmail
  createQueryThreadElementCropper("div.gmail_quote.gmail_quote_container"),
  // Outlook
  createHtmlSeparatorThreadElementCropper('<div id="appendonsend"></div>'),
  // Outlook mobile
  createQuerySeparatorThreadElementCropper("div#ms-outlook-mobile-body-separator-line"),
];

const removeThreadFromEmailHtml = (
  html: string
): [bodyHtml: HTMLElement, threadHtml: string | undefined] => {
  const parser = new DOMParser();
  const document = parser.parseFromString(html, "text/html");

  let threadElementHtml: string | undefined = undefined;
  for (const cropThreadElement of threadElementCroppers) {
    threadElementHtml = cropThreadElement(document);
    if (threadElementHtml) {
      break;
    }
  }

  return [document.body, threadElementHtml];
};

export default removeThreadFromEmailHtml;
